import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export default <FunctionalComponentOptions>{
    name: 'WokButtonsStack',
    
    functional: true,

    props: {
        kind: {
            type: String,
            default: 'horizontal',
            validator: (v: string) => v == '' || /(vertical|horizontal)/.test(v)
        },
        align: {
            type: String,
            default: 'right',
            validator: (v: string) => v == '' || /(left|center|right)/.test(v)
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'div', { class: [
                'wok--buttons-stack',
                `wok--buttons-stack--${ctx.props.kind}`,
                `wok--buttons-stack--${ctx.props.align}`, 
                ctx.data.staticClass
            ] }, [
                ctx.slots().default
            ]
        )
    }
}